// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Footer style */\n\n/* Classes */\n.footer {\n    position: absolute;\n    bottom: 5px;\n    width: 100%;\n}\n\n.footer-text {\n    font-size: 0.8rem;\n}\n\n/**************************** Lower 520px ****************************/\n@media (max-width: 520px) {\n    .footer-text {\n        font-size: 0.7rem;\n    }\n}", ""]);
// Exports
module.exports = exports;
